"use client";

import { useProducts } from "@/hooks/useProduct";
import { cn, extractKeyTextValue } from "@/lib/utils";
import { renderProductCard } from "@/components/molecules/render-product-card";
import { Locales } from "@/lib/i18n";
import { CategorieDocument, ProductDocument } from "@/prismicio-types";

type ProductsGridClientProps = {
  products: ProductDocument[] | null;
  locale: Locales;
  className?: string;
  collectionCategories: CategorieDocument[][] | null;
};

const ProductsGridClient = ({ products, locale, className, collectionCategories }: ProductsGridClientProps) => {
  const uids = products?.map((product) => extractKeyTextValue(product.data.medusaId)) ?? [];

  const { data: medusaProducts, isLoading } = useProducts(locale, uids, uids.length > 0);

  if (!products || !collectionCategories) return null;

  return (
    <ul className={cn("grid w-full grid-cols-2 gap-4 sm:grid-cols-3 lg:flex-grow", className)}>
      {products.map((product, index) => {
        const medusaId = extractKeyTextValue(product.data.medusaId);
        const medusaProduct = medusaProducts?.[medusaId];
        const category = collectionCategories?.[index]?.[0];

        return (
          <li key={medusaId}>
            {renderProductCard({
              product,
              medusaProduct,
              category,
              locale,
              isLoading,
              className: "min-w-full md:max-w-full",
            })}
          </li>
        );
      })}
    </ul>
  );
};

export default ProductsGridClient;
